/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

import { gsap } from 'gsap';
import MorphSVGPlugin from 'gsap/MorphSVGPlugin';

import Draggable from 'gsap/Draggable';

// styles and images
import styles from './Graphics.module.css';

// components

/*****************************************
 * * CREATE COMPONENT
 *****************************************/
class Graphics extends Component {
  morphSVG = MorphSVGPlugin;
  anim = null;

  componentDidMount() {
    gsap.registerPlugin(MorphSVGPlugin, Draggable);

    // send this component reference to parent
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.timeScale !== this.props.timeScale) {
      let isPause = this.anim.paused();
      this.anim.pause();
      this.anim.timeScale(this.props.timeScale);
      if (!isPause) {
        this.anim.resume();
      }
    }
  }

  createAnimation(createAnim, pathRefs) {
    if (this.anim) {
      this.anim.kill();
      let origines = [...document.querySelectorAll('.removable')];
      origines.forEach(el => el.remove())

    }
    this.anim = gsap.timeline({
      paused: true,
      repeat: -1,
      repeatDelay: 0,
      // yoyo: true,
    });

    this.anim.defaultEase = 'power1.inOut';

    createAnim(this.anim, pathRefs, this.props.speed);
  }

  play() {
    this.anim.play();
  }
  pause() {
    this.anim.pause();
  }

  render() {
    const { content } = this.props.content;
    const { viewBox } = this.props;

    return (
      <>
        <svg
          className={styles.graphics}
          id='svg'
          viewBox={viewBox}
          ref={ref => (this.svg = ref)}
        >
          {content}
        </svg>
      </>
    );
  }
}

export default Graphics;
